/* ============
 * Mutation types for the Management protocol template module
 * ============
 *
 * The mutation types that are available
 * on the Management protocol template module.
 */
import keyMirror from 'key-mirror';

export default keyMirror({

  GET_MANAGEMENT_PROTOCOL_TEMPLATE: null,
  GET_MANAGEMENT_PROTOCOL_TEMPLATE_SUCCESS: null,
  GET_MANAGEMENT_PROTOCOL_TEMPLATE_FAIL: null,

  GET_PROTOCOL_LIST: null,
  GET_PROTOCOL_LIST_SUCCESS: null,
  GET_PROTOCOL_LIST_FAIL: null,
});
